export { isTbclLevelKey, TBCL_LEVELS, type TbclLevelKey } from "#tbcl-levels";
